<template>
    <div class="zjdContainer">
        <div v-if="!isWinning" >
        <div style="height:425px;">
            <img style="width: 100%" :src="mubu" alt="">
        </div>
        <div class="zjdtitle">
            <span class="myprize">金蛋来袭，砸出好礼</span>
        </div>
        <div class="eggarray one">
            <div class="egglist">
                <div v-for="(i,index) in eggarr1.num1" :key="index">
                    <div :ref="'chuizi'+index" class="egg" @click="clickOne(index)"> 
                        <!-- 锤子图片 -->
                        <img :ref="'chuizi'+index" class="chuizi" :class="{'qiao':eggarray.qiao && eggarray.egg ==index}" :src="chuiziimg" alt/>
                        <!-- 鸡蛋图片 -->
                        <img class="eg " :class="{'qiao':eggarray.qiao && eggarray.egg == index}" :src="eggimg" alt />
                        <!-- 鸡蛋图片 -->
                    </div>
                    <div class="egg hidden egggx" :ref="'chuizi'+index">
                        <img class="eg" :class="{'eggbroken':eggarray.qiao && eggarray.egg == index}" :src="eggbrokenimg" alt />
                    </div>
                </div>
            </div>
            <div class="egglist">
                <div v-for="(i,index) in eggarr1.num2" :key="index">
                    <div :ref="'chuizin'+2+index" class="egg egs" @click="clickOne(2+index)">
                        <!-- 锤子图片 -->
                        <img :ref="'chuizin'+2+index" class="chuizi" :class="{'qiao':eggarray.qiao && eggarray.egg ==2+index}" :src="chuiziimg" alt />
                        <!-- 鸡蛋图片 -->
                        <img :ref="'chuizin'+2+index" class="eg " :class="{'qiao':eggarray.qiao && eggarray.egg == 2+index}" :src="eggimg" alt />
                        <!-- 鸡蛋图片 -->
                    </div>
                    <div class="egg hidden egggx" :ref="'chuizin'+2+index">
                        <img class="eg" :class="{'eggbroken':eggarray.qiao && eggarray.egg == 2+index}" :src="eggbrokenimg" alt />
                    </div>
                </div>
            </div>
        </div>
        <!-- <a href="javascript:;" class="bottxt" @click="getWinning()">领取礼品</a> -->
        <div class="bottom_tip">奖品由 {{activatesource}} 赞助</div>
        </div>
        <!-- 中奖弹窗 -->
        <div class="popdiv" v-if="isWinning">
            <!-- <img class="popbox" style="" :src="quit" alt="" @click="closetoast"> -->
            <div class="lottery-alertgx">
                <div class="winbg bg_head">{{winResult.level_name}}</div>
                <div class="winbg bg_content">
                    <div class="lottery-alerth1" style="color:#333;font-size:16px;"><b style="color:#ff4343;">{{winResult.present_name}}</b></div>
                    <div id="qrcode" ref="qrcode" style="padding:20px 0;">
                        <img :src="winResult.img_url" style="width: 160px;" />
                    </div>
                   
                </div>
                <div class="winbg bg_foot">
                    <div style="bottom: 65px;
                    left: 50%;
                    transform: translateX(-50%);
                    position: absolute;"> <el-button round size="medium" @click="getWinning()">领取</el-button></div>
                    <p class="right_word">礼品领取方式，可在<span  @click="getWinning()">【我的礼品】</span>处进行地址填写</p>
                </div>
            </div>
        </div>
        <!-- 中奖纪录 -->
        <div class="recodeList" v-if="recodePop">
            <img class="popbox2" style="" :src="quit2" alt="" @click="closeRecode">
            <div class="caption">中奖纪录</div>
            <table cellpadding="10px" cellspacing="10px" class="recode_table">
                <thead>
                <tr>
                    <th width="100px">序号</th>
                    <th width="130px">奖项</th>
                    <th width="200px">奖品名称</th>
                    <th width="200px">举办方</th>
                    <!-- <th>赞助商</th> -->
                    <th width="150px">中奖时间</th>
                </tr>
                </thead>
                <tbody class="tbody">
                    <tr v-for="(item, i) in recodeList" :key="item">
                        <td>{{(i+1)}}</td>
                        <td>{{item.level_name}}</td>
                        <td>{{item.present_name}}</td>
                        <td>{{item.org_name}}</td>
                        <td>{{item.create_time}}</td>
                    </tr>
                </tbody>
            </table>
            <p class="right_word">礼品领取方式，可在<sppan  @click="getWinning">【我的礼品】</sppan>处进行地址填写</p>
        </div>
        <!-- 开奖等待 -->
        <div class="kj_loading" v-if="isKjloading"><img src="../assets/zjd_img/active.gif" /></div>


    </div>
</template>

<script>
  import Axios from "@/api/diyaxios";
  import Cookies from 'js-cookie'

export default {
    props: ['activateinfo','recodePop','activatesource','activateid'],//砸金蛋活动id
    data(){
        return{
            timelist: "",
            isKjloading: false,
            quit: require('../assets/zjd_img/quit.png'),
            quit2: require('../assets/zjd_img/quit2.png'),
            mubu: require('../assets/zjd_img/mubu.png'),
            chuiziimg: require('../assets/zjd_img/chuizi.png'),
            eggimg: require('../assets/zjd_img/egg.png'),
            eggbrokenimg: require('../assets/zjd_img/eggbroken.png'),
            eggarr1: {
                num1: 2,
                num2: 3,
            },
            eggarray: {
                num: 5, //默认蛋数量
                egg: null, //敲击的哪个鸡蛋
                qiao: false, //是否敲击
            },
            isWinning: false,//手机奖品弹框是否显示
            // showToast: , //显示中奖弹窗
            //砸金蛋结果
            winResult: null,
            actInfo: {},  //供应商名称
            recodePop: false,
            recodeList: [] , //中奖记录
            imagesUrl:'',
        }
    },
    components:{},
    created(){
        let vm = this;
        vm.actInfo = vm.activateinfo;
        // this.getWinningRecord()
        // this.aaa()
    },
    mounted(){
        let vm = this;
        vm.timelist = vm.$route.query.time
        // if(Cookies.get('egg')){
        //     vm.eggarray.egg = Cookies.get('egg')
        //     vm.eggarray.qiao = true
        // }
        vm.$nextTick(() => {
            for (let i = 0; i < (vm.eggarr1.num1); i++) {
                let ref = "chuizi" + i;
                vm.$refs[ref][i].addEventListener("webkitAnimationEnd", () => {
                    //动画结束时事件
                    vm.$refs[ref][0].style.display = "none";
                    vm.$refs[ref][1].style.display = "none";
                    vm.$refs[ref][2].style.display = "block";
                    vm.$refs[ref][2].style.height = "158px";

                });
            }
            for (let i = 0; i < 3; i++) {
                let ref = "chuizin" + 2 + i;
                vm.$refs[ref][i].addEventListener("webkitAnimationEnd", () => {
                    //动画结束时事件
                    vm.$refs[ref][0].style.display = "none";
                    vm.$refs[ref][1].style.display = "none";
                    vm.$refs[ref][2].style.display = "none";
                    vm.$refs[ref][3].style.display = "block";
                    vm.$refs[ref][3].style.height = "158px";
                });
            }
        })
    },
    methods:{
        getWinning(){
            this.$router.push({name:"myPrice"})
        },

        aaa(){
            if(this.eggarray.qiao){
                this.isWinning = true
            }
        },
        //敲击鸡蛋的方法
        clickOne(index) {
            this.hiteggs(index)
            //敲击过一次就不能再敲击
        },
        //抽奖动效
        hiteggs(index) {
            let vm = this;
                Axios.post('/gold/activate/openbox', {
                    params:{
                        userid: Cookies.get("UserID"),
                        activateid: vm.activateid,
                    }
                }, {
                        headers: {
                            "Content-Type": "application/json",
                            token: Cookies.get('token')
                        }
                    }
                ).then(res => {
                    if(res.code !='200'){
                        vm.$alert(res.msg ,{
                        confirmButtonText: '确定'
                        });
                    }else{
                    this.imagesUrl = res.data.img_url
                    vm.$nextTick(() => {
                        vm.eggarray.qiao = true;
                        vm.eggarray.egg = index; //显示砸的哪一个
                        Cookies.set("egg",vm.eggarray.egg)
                        if(res.code == '200'){
                            vm.winResult = res.data;
                            vm.isKjloading = true;
                            let times = setTimeout(() => {
                                vm.isKjloading = false
                                let str = '';
                                if(vm.winResult.present_id == '1'){
                                    str = '一等奖';
                                }else if(vm.winResult.present_id == '2'){
                                    str = '二等奖';
                                }else if(vm.winResult.present_id == '3'){
                                    str = '三等奖';
                                }else if(vm.winResult.present_id == '4'){
                                    str = '参与奖';
                                }else if(vm.winResult.present_id == '5'){
                                    str = '未中奖！';
                                }
                                vm.winResult.level_name = str;
                                vm.isWinning = true;

                            }, 3000);
                        }
                    })
                    }
                    
                }).catch(err => {
                    if(err.res.code == '1000'){
                        vm.$alert(err.res.msg || '您已经参与过了！请等待下一场活动...','温馨提示',{
                            confirmButtonText: '确定'
                        });
                    }else{
                        vm.$alert(err.msg ,{
                            confirmButtonText: '确定'
                        });
                    }
                });

        },
        // closetoast() {
        //     // this.showToast = false;
        //     this.isWinning = false;
        //     // this.getWinning();
        //     this.$parent.getNowActiveInfo();
        // },
        closeRecode(){
            this.recodePop = false;
        },
        //查询中奖纪录
        getWinningRecord(){
            let vm = this;
            if (Cookies.get('token')) {
                Axios.post('/gold/activate/getrecordlist', {
                    params:{
                        selecttj: 'gold_activate_record.user_id='+Cookies.get("UserID"),
                        ordertj: '',
                        pageSize:100,
                        pageNum:1,
                    }
                }, {
                        headers: {
                            "Content-Type": "application/json",
                            token: Cookies.get('token')
                        }
                    }
                ).then(res => {
                    if(res.status){
                       if(res.data.length > 0){
                                vm.winResult = res.data[0];
                                let str = '';
                                if(vm.winResult.present_id == '1'){
                                    str = '一等奖';
                                }else if(vm.winResult.present_id == '2'){
                                    str = '二等奖';
                                }else if(vm.winResult.present_id == '3'){
                                    str = '三等奖';
                                }else if(vm.winResult.present_id == '4'){
                                    str = '参与奖';
                                }else if(vm.winResult.present_id == '5'){
                                    str = '未中奖！';
                                }
                                vm.winResult.level_name = str;
                                vm.isWinning = true
                       }else{
                        vm.isWinning = false
                        //    vm.recodePop = false; //显示中奖纪录
                        //    //提示暂无中奖纪录！
                        //     vm.$alert('暂无中奖纪录！','温馨提示',{
                        //         confirmButtonText: '确定'
                        //     });

                       }
                    }
                }).catch(err => {

                });
            }else{
                this.$router.push({ name: 'Login'});
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.kj_loading{
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.8);
    z-index: 9;
    overflow-y: hidden;
    top: 0;
    left: 0;
    >img{
        position: relative;
        top:50%;
        margin-top:-150px;
        width:300px;
        height:300px;
    }
}
.zjdContainer  {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #666; 
        background-color: #bd2a33;
        height: 100%;
         width: 100%;
    }
    .bottxt{
        font-size: 12px;
        position: absolute;
        bottom: 50px;
        width: 100%;
        display: block !important;
        /* margin-left: 4%; */
        text-align: center;
        color: #f8a1a1;
    }
    .bottom_tip{
        font-size:12px;
        position: absolute;
        bottom: 25px;
        width: 92%;
        margin-left: 4%;
        color: #ff8888;
    }
    .zjdtitle{
        position: absolute;
        top: 20px;
        width:100%;
    }
    .egglist  {
        display: -webkit-inline-flex;
        display: -moz-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        margin-left: -30px;
        margin-top: 30px;
    }

    .eggarray  {
        position: relative;
        top: -400px;
    }
    .myprize  {
        -moz-border-radius: 20px;
        border-radius: 20px;
        padding: 8px 20px;
        color: #edd251;
        font-weight: bold;
        font-size: 18px;
        // background: #fff;
    }

    .eggarray.one  {
        -webkit-justify-content: center;
        -moz-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-transform: scale(.7);
        -moz-transform: scale(.7);
        -ms-transform: scale(.7);
        -o-transform: scale(.7);
        transform: scale(.7);
    }

    .eggarray.one .egg  {
        cursor: pointer;
        margin: 15px 25px;
        position: relative;
        width: 110px;
        height: 158px;
    }

    .eggarray.one .egg:hover .chuizi  {
        opacity: 1
    }

    .eggarray.one .egg img  {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        pointer-events: none;
    }

    .eggarray.one .egg .eg  {
        height: 100%;
        -webkit-transform: scale(1.3);
        -moz-transform: scale(1.3);
        -ms-transform: scale(1.3);
        -o-transform: scale(1.3);
        transform: scale(1.3);
    }

    .eggarray.one .egg .eg.qiao  {
        -webkit-animation: clickOne_eg-data-v-79ae374a .5s steps(1) .4s 1 both;
        -moz-animation: clickOne_eg-data-v-79ae374a .5s steps(1) .4s both 1;
        -o-animation: clickOne_eg-data-v-79ae374a .5s steps(1) .4s both 1;
        animation: clickOne_eg-data-v-79ae374a .5s steps(1) .4s 1 both
    }

    .eggarray.one .egg .egs  {
        margin: 8px;
    }

    .eggarray.one .egg .chuizi  {
        -webkit-transform-origin: 100% 100%;
        -moz-transform-origin: 100% 100%;
        -ms-transform-origin: 100% 100%;
        -o-transform-origin: 100% 100%;
        transform-origin: 100% 100%;
        opacity: 0;
        position: absolute;
        left: 72px;
        bottom: 135px;;
        z-index: 9;
        height: 75px;
    }

    .eggarray.one .egg .chuizi.qiao  {
        -webkit-animation: clickOne_chuizi-data-v-79ae374a .7s ease-in 1 both;
        -moz-animation: clickOne_chuizi-data-v-79ae374a .7s ease-in both 1;
        -o-animation: clickOne_chuizi-data-v-79ae374a .7s ease-in both 1;
        animation: clickOne_chuizi-data-v-79ae374a .7s ease-in 1 both;
        -webkit-animation-fill-mode: hidden;
        -moz-animation-fill-mode: hidden;
        -o-animation-fill-mode: hidden;
        animation-fill-mode: hidden
    }

    .eggarray.one .hidden  {
        display: none
    }
    .popbox{
        height: 42px;
        width: 42px;
        position: absolute;
        bottom: 55px;
        left: 50%;
        z-index: 999;
        margin-left: -21px;
        cursor: pointer;
    }
    .popbox2{
        height: 42px;
        width: 42px;
        position: absolute;
        top: 5px;
        right: 5px;
        z-index: 999;
        margin-left: -21px;
        cursor: pointer;
    }
    .recode_table .tbody{
        font-size:12px;
    }

    @-webkit-keyframes clickOne_chuizi-data-v-79ae374a {
        50% {
            -webkit-transform: rotate(30deg);
            transform: rotate(30deg)
        }
        99% {
            opacity: 1;
            -webkit-transform: rotate(0);
            transform: rotate(0)
        }
        to {
            opacity: 0;
            -webkit-transform: rotate(0);
            transform: rotate(0)
        }
    }

    @-moz-keyframes clickOne_chuizi-data-v-79ae374a {
        50% {
            -moz-transform: rotate(30deg);
            transform: rotate(30deg)
        }
        99% {
            opacity: 1;
            -moz-transform: rotate(0);
            transform: rotate(0)
        }
        to {
            opacity: 0;
            -moz-transform: rotate(0);
            transform: rotate(0)
        }
    }

    @-o-keyframes clickOne_chuizi-data-v-79ae374a {
        50% {
            -o-transform: rotate(30deg);
            transform: rotate(30deg)
        }
        99% {
            opacity: 1;
            -o-transform: rotate(0);
            transform: rotate(0)
        }
        to {
            opacity: 0;
            -o-transform: rotate(0);
            transform: rotate(0)
        }
    }

    @keyframes clickOne_chuizi-data-v-79ae374a {
        50% {
            -webkit-transform: rotate(30deg);
            -moz-transform: rotate(30deg);
            -o-transform: rotate(30deg);
            transform: rotate(30deg)
        }
        99% {
            opacity: 1;
            -webkit-transform: rotate(0);
            -moz-transform: rotate(0);
            -o-transform: rotate(0);
            transform: rotate(0)
        }
        to {
            opacity: 0;
            -webkit-transform: rotate(0);
            -moz-transform: rotate(0);
            -o-transform: rotate(0);
            transform: rotate(0)
        }
    }

    @-webkit-keyframes clickOne_eg-data-v-79ae374a {
        to {
            opacity: 0
        }
    }

    @-moz-keyframes clickOne_eg-data-v-79ae374a {
        to {
            opacity: 0
        }
    }

    @-o-keyframes clickOne_eg-data-v-79ae374a {
        to {
            opacity: 0
        }
    }

    @keyframes clickOne_eg-data-v-79ae374a {
        to {
            opacity: 0
        }
    }

   



    /* .lottery-alertgx  {
        -moz-border-radius: 15px;
        border-radius: 15px;
    } */

   .lottery-alertgx , .lottery-tip  {
        /* max-width: 100%;
        text-align: center; */
        /* z-index: 10000; */

        /* -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        -o-transform: translateY(-50%);
        transform: translateY(-50%) */
    }

    .lottery-alerth1  {
        font-size: 20px;
        font-weight: 400;
        color: #000;
        position: relative;
    }

    .right_word {
        span {
            cursor: pointer;
            color: #fff;
        }
    }

    .lottery-alert img  {
        display: block;
        height: 120px;
        margin: 0 auto
    }

    .lottery-alert p  {
        color: #666;
        font-size: 16px;
        padding-top: 2px;
    }

    .lottery-alert .btnsave  {
        margin: 0 20px;
    }

    .lottery-alert .btnsave , .lottery-alertgx .btnsave  {
        height: 40px;
        line-height: 40px;
        color: #fff;
        background-color: #ff4343;
        -moz-border-radius: 8px;
        border-radius: 8px;
        font-size: 15px;
    }

    .lottery-alertgx .btnsave  {
        margin: 0 35px;
    }

    .nnk-home-desc-box .nnk-home-desc div  {
        line-height: 24px;
    }


    .gxdiv , .yhdiv  {
        background-repeat: no-repeat;
        -moz-background-size: 100% 100%;
        background-size: 100% 100%;
        padding-top: 85px;
        font-size: 20px;
    }
    .winbg{
        width: 420px;
    }
    .bg_head{
        height:126px;
        background: url(../assets/zjd_img/gx_01.png) no-repeat;
        text-align: center;
        color: #fff;
        font-weight: bold;
        font-size: 24px;
        line-height: 150px;
    }
    .bg_content {
        background: url(../assets/zjd_img/gx_02.png) repeat-y;
        // width: 420px;
        min-height: 200px;
        // padding-bottom: 8px;
    }
    .bg_foot{
        height: 53px;
        background: url(../assets/zjd_img/gx_03.png) no-repeat;
    }

    .prizetitle  {
        margin-bottom: 15px;
        margin-top: 12px;
        font-size: 12px;
        padding: 0 35px;
        text-align: center
    }

    .popdiv {
        /* position: fixed;
        left: 50%;
        top: 50%;
        margin-left: -200px;
        z-index: 226; */
    }
    .recodeList{
        position: fixed;
        left: 50%;
        top: 50%;
        // margin-top: -270px;
        margin-top: -265px;
        // margin-left: -380px;
        margin-left: -265px;
        z-index: 226;
        // width: 760px;
        width: 565px;
        // height: 520px;
        height: 500px;
        background-color: #f0ebdc;
        border: 3px solid #b9151f;
        border-radius: 20px;
        padding: 20px;
    }
    .caption{
        color: #b9151f;
        font-weight: bold;
        font-size:24px;
        margin-bottom: 30px;
    }
    .barrages-drop .hidden  {
        display: none
    }
</style>



// WEBPACK FOOTER //
// src/components/testcopy.vue